/** 
 * @type {import("./defs").StoreInvestor} 
 */
const store = {
}
/** 
* @returns {import("./defs").StoreInvestor} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StoreInvestor.js